module.exports = __webpack_public_path__ + "static/media/June_2026_1.ad3a5d93.webp";